import React from "react";
import VisorPluginPlaceholder from "../../_visor/components/canvas/VisorPluginPlaceholder";
import VisorSortableList from "../../_visor/components/common/VisorSortableList";
import QuizStatusLine from "../../_visor/components/canvas/QuizStatusLine";
import { contentI18n as i18n } from "../../common/content_language";
import { setRgbaAlpha, shuffle, getButtonText } from "../../common/common_tools";
import { MATCHING_RIGHT_OFFSET } from "../../common/constants";
/* eslint-disable react/prop-types */
export default class MatchingVisor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      positions: this.generateRandomPositions(this.props.state.nBoxes),
      positions2: this.generateRandomPositions(this.props.state.nBoxes),
    };
    // Two independent dnd-kit lists (static left prompts + draggable right
    // answers) can't align row-for-row with pure CSS, and forcing uniform
    // flex heights clips multi-line text. So equalize each facing pair in JS.
    this.rowContainerRef = React.createRef();
  }

  componentDidUpdate() {
    this.syncRowHeights();
  }

  componentWillUnmount() {
    if (this._ro) this._ro.disconnect();
  }

  // Match the height of left row i to right row i (and vice versa) so the two
  // Matching columns line up pair-for-pair regardless of content length.
  syncRowHeights = () => {
    const container = this.rowContainerRef.current;
    if (!container) return;
    const left = container.querySelectorAll(".flex-row-item:first-child .vsl-row");
    const right = container.querySelectorAll(".flex-row-item:last-child .vsl-row");
    const n = Math.min(left.length, right.length);
    // Reset first so natural heights are measured, not last pass's forced ones.
    for (let i = 0; i < n; i++) {
      left[i].style.height = "auto";
      right[i].style.height = "auto";
    }
    for (let i = 0; i < n; i++) {
      const h = Math.max(left[i].offsetHeight, right[i].offsetHeight);
      left[i].style.height = h + "px";
      right[i].style.height = h + "px";
    }
  };

  render() {
    let { state, props } = this.props;
    let attempted = props.exercises && props.exercises.attempted;
    let score = props.exercises.score || 0;
    score = Math.round(score * 100) / 100;
    score =
      props.exercises.weight === 0
        ? i18n.t("Ordering.notCount")
        : score + "/" + props.exercises.weight;
    let showFeedback = attempted && state.showFeedback;

    let istrue =
      attempted &&
      JSON.stringify(this.props.props.exercises.currentAnswer.positionleft) ==
        JSON.stringify(this.props.props.exercises.currentAnswer.positionright);

    const isTryAgainMode =
      state.buttons === "tryAgain" ||
      state.buttons === i18n.t("MultipleChoice.tryAgain") ||
      state.buttons === "Try Again" ||
      state.buttons === "Tekrar Dene";
    const showAnswerStyles = attempted && (!isTryAgainMode || istrue);

    let quizColor = state.buttonBackgroundColor || state.quizColor || "rgba(237, 233, 254, 1)";
    let buttonStyles = {
      backgroundColor: state.buttonBackgroundColor || "#ede9fe",
      color: state.buttonTextColor || "#111827",
      borderColor: state.buttonBorderColor || "#ede9fe",
      borderWidth: `${state.buttonBorderWidth || 1}px`,
      borderRadius: `${state.buttonBorderRadius || 4}px`,
      borderStyle: "solid",
      padding: `${state.buttonPadding || 8}px ${(state.buttonPadding || 8) * 1.5}px`,
      fontSize: `${state.buttonFontSize || 14}px`,
      fontWeight: state.buttonFontWeight || "normal",
      cursor: "pointer",
      margin: "2px",
      transition: "background-color 0.2s ease",
    };
    let correctAnswers = "";
    let positions = attempted ? props.exercises.currentAnswer.positionleft : this.state.positions;
    let positions2 = attempted
      ? props.exercises.currentAnswer.positionright
      : this.state.positions2;

    // Left column = the fixed prompts (not draggable). Render with the SAME card
    // shell as the draggable right column (vsl-row--static) so the two columns
    // are identical in size and align row-for-row.
    const leftItems = positions.map((answerIdx) => ({
      id: answerIdx,
      content: (
        <VisorPluginPlaceholder
          {...props}
          key={answerIdx + 1}
          pluginContainer={"Answer" + answerIdx}
        />
      ),
    }));
    // Right column = the draggable "answers". dnd-kit item id is the answer
    // index (positions2[j]); reordering the ids IS the new positionright array.
    // Left column (above) stays fixed. Scoring (correctArrayOrdered) unchanged.
    const sortItems2 = positions2.map((answerIdx, j) => {
      // Tekrar ("Try Again") modunda hiç renk verilmez (cevap gizli kalsın); sonuç
      // buton altındaki durum satırında. Diğer modlarda satır bazında yeşil/kırmızı;
      // doğru cevabı ifşa eden etiket yalnızca seeAnswer'da gösterilir.
      const correct = attempted && !isTryAgainMode && positions[j] === positions2[j];
      const incorrect = attempted && !isTryAgainMode && positions2[j] !== positions[j];
      return {
        id: answerIdx,
        content: (
          <>
            <VisorPluginPlaceholder
              {...props}
              key={answerIdx + MATCHING_RIGHT_OFFSET + 1}
              pluginContainer={"Answer" + (answerIdx + MATCHING_RIGHT_OFFSET)}
            />
            {incorrect && showAnswerStyles ? (
              <span className="matchingCorrectLabel">
                {i18n.t("Ordering.Matching.Correct") +
                  ": " +
                  i18n.t("Ordering.Matching.Answer") +
                  " " +
                  (positions[j] + 1)}
              </span>
            ) : null}
          </>
        ),
        status: correct ? "correct" : incorrect ? "incorrect" : null,
      };
    });

    let trueFeedbackContainer = props.boxes[props.id].sortableContainers["sc-TrueFeedback"];
    let trueFeedbackToolbar = trueFeedbackContainer?.children?.[0]
      ? props.toolbars[trueFeedbackContainer.children[0]]
      : null;

    let falseFeedbackContainer = props.boxes[props.id].sortableContainers["sc-FalseFeedback"];
    let falseFeedbackToolbar = falseFeedbackContainer?.children?.[0]
      ? props.toolbars[falseFeedbackContainer.children[0]]
      : null;

    let fixImgSvgStructure = (text) => {
      if (!text || typeof text !== "string") return text;
      let decoded = text;
      try {
        if (text.includes("%3C") || text.includes("%3E")) {
          decoded = decodeURIComponent(text);
        }
      } catch (e) {}

      decoded = decoded.replace(/<img\s*([^>]*?)>([\s\S]*?)<\/img>/gi, (match, attrs, content) => {
        if (content && content.trim() && content.includes("<svg")) {
          let spanAttrs = attrs ? attrs.trim() : "";
          if (spanAttrs && spanAttrs.includes("style=")) {
            spanAttrs = spanAttrs.replace(
              /style\s*=\s*["']([^"']*)["']/i,
              (styleMatch, styleContent) => {
                let cleanStyle = styleContent.trim().replace(/;\s*$/, "");
                return `style="${cleanStyle};display:inline-block;"`;
              }
            );
          } else {
            spanAttrs = (spanAttrs ? spanAttrs + " " : "") + 'style="display:inline-block;"';
          }
          return `<span ${spanAttrs}>${content}</span>`;
        }
        return match;
      });
      decoded = decoded.replace(/<img\s*([^>]*?)>\s*<svg/gi, (match, attrs) => {
        let spanAttrs = attrs ? attrs.trim() : "";
        if (spanAttrs && spanAttrs.includes("style=")) {
          spanAttrs = spanAttrs.replace(
            /style\s*=\s*["']([^"']*)["']/i,
            (styleMatch, styleContent) => {
              let cleanStyle = styleContent.trim().replace(/;\s*$/, "");
              return `style="${cleanStyle};display:inline-block;"`;
            }
          );
        } else {
          spanAttrs = (spanAttrs ? spanAttrs + " " : "") + 'style="display:inline-block;"';
        }
        return `<span ${spanAttrs}><svg`;
      });
      decoded = decoded.replace(/<\/svg>[\s\n]*<\/img>/gi, "</svg></span>");
      if (text.includes("%3C") || text.includes("%3E")) {
        try {
          return encodeURIComponent(decoded);
        } catch (e) {
          return decoded;
        }
      }
      return decoded;
    };

    let trueFeedbackText = fixImgSvgStructure(trueFeedbackToolbar?.state?.__text || "");
    let isDefaultTrueFeedbackMsg = false;

    let defaultTrueFeedbackMsg = "<p>" + i18n.t("MultipleChoice.TrueFeedbackMsg") + "</p>";

    if (
      trueFeedbackText === defaultTrueFeedbackMsg ||
      trueFeedbackText === encodeURI(defaultTrueFeedbackMsg) ||
      trueFeedbackText === encodeURI(defaultTrueFeedbackMsg + "\n") ||
      trueFeedbackText.includes(i18n.t("MultipleChoice.TrueFeedbackMsg"))
    ) {
      isDefaultTrueFeedbackMsg = true;
    }

    let checkEmptyTrueFeedback =
      (!trueFeedbackContainer?.children ||
        trueFeedbackContainer.children.length === 0 ||
        trueFeedbackToolbar?.state?.__text === "<p>" + i18n.t("text_here") + "</p>" ||
        trueFeedbackToolbar?.state?.__text === encodeURI("<p>" + i18n.t("text_here") + "</p>") ||
        trueFeedbackToolbar?.state?.__text === encodeURI("<p>" + i18n.t("text_here") + "</p>\n")) &&
      !isDefaultTrueFeedbackMsg;

    let falseFeedbackText = fixImgSvgStructure(falseFeedbackToolbar?.state?.__text || "");
    let isDefaultFalseFeedbackMsg = false;

    let defaultFalseFeedbackMsg = "<p>" + i18n.t("MultipleChoice.FalseFeedbackMsg") + "</p>";

    if (
      falseFeedbackText === defaultFalseFeedbackMsg ||
      falseFeedbackText === encodeURI(defaultFalseFeedbackMsg) ||
      falseFeedbackText === encodeURI(defaultFalseFeedbackMsg + "\n") ||
      falseFeedbackText.includes(i18n.t("MultipleChoice.FalseFeedbackMsg"))
    ) {
      isDefaultFalseFeedbackMsg = true;
    }

    let checkEmptyFalseFeedback =
      (!falseFeedbackContainer?.children ||
        falseFeedbackContainer.children.length === 0 ||
        falseFeedbackToolbar?.state?.__text === "<p>" + i18n.t("text_here") + "</p>" ||
        falseFeedbackToolbar?.state?.__text === encodeURI("<p>" + i18n.t("text_here") + "</p>") ||
        falseFeedbackToolbar?.state?.__text ===
          encodeURI("<p>" + i18n.t("text_here") + "</p>\n")) &&
      !isDefaultFalseFeedbackMsg;

    return (
      <div
        className={
          "exercisePlugin matchingPlugin" +
          (attempted ? " attempted " : " ") +
          (isTryAgainMode ? " matching-tryagain " : " ") +
          (props.exercises.showFeedback ? "showFeedback" : "")
        }
        style={{ "--q-btn-hover-bg": state.buttonHoverBackgroundColor || "#ede9fe" }}
      >
        <div className={"row"} key={0}>
          <div className={"col-xs-12"}>
            <VisorPluginPlaceholder {...props} key="0" pluginContainer={"Question"} />
          </div>
        </div>
        <div className="row flex-row-container" ref={this.rowContainerRef}>
          <div className="flex-row-item">
            <ul className="vsl-list">
              {leftItems.map((it, j) => (
                <li key={it.id} className="vsl-row vsl-row--static">
                  <span className="vsl-badge" aria-hidden="true">
                    {j + 1}
                  </span>
                  <div className="vsl-body">{it.content}</div>
                </li>
              ))}
            </ul>
          </div>
          <div className="flex-row-item">
            <VisorSortableList
              items={sortItems2}
              disabled={!!attempted}
              ariaLabel={i18n.t("Ordering.Matching.PluginName") || "Matching"}
              onReorder={(newOrder) =>
                this.setState({ positions2: newOrder }, () => {
                  this.props.props.setAnswer({
                    positionleft: this.state.positions,
                    positionright: this.state.positions2,
                  });
                })
              }
            />
          </div>
        </div>

        {istrue && !checkEmptyTrueFeedback ? (
          <div
            className={"row feedbackRow"}
            key={-2}
            style={{ display: showFeedback ? "block" : "none" }}
          >
            <div
              className={"col-xs-12 feedback"}
              role="status"
              aria-live="polite"
              style={{
                color: /* quizColor */ "black",
                borderColor: "#318533",
                backgroundColor: setRgbaAlpha("rgba(39,208,124,0.20)", 0.15),
                display: "flex",
                alignItems: "center",
              }}
            >
              <VisorPluginPlaceholder {...props} key="0" pluginContainer={"TrueFeedback"} />
            </div>
          </div>
        ) : null}
        {!istrue && !checkEmptyFalseFeedback ? (
          <div
            className={"row feedbackRow"}
            key={-2}
            style={{ display: showFeedback ? "block" : "none" }}
          >
            <div
              className={"col-xs-12 feedback"}
              role="status"
              aria-live="polite"
              style={{
                color: /* quizColor */ "black",
                borderColor: "#a31111",
                backgroundColor: setRgbaAlpha("rgba(213,26,26,0.20)", 0.15),
                display: "flex",
                alignItems: "center",
              }}
            >
              <VisorPluginPlaceholder {...props} key="1232" pluginContainer={"FalseFeedback"} />
            </div>
          </div>
        ) : null}

        {isTryAgainMode && !state.showFeedback ? (
          <QuizStatusLine correct={istrue} visible={attempted} />
        ) : null}

        <div className={"exerciseScore"} style={{ color: quizColor }}>
          {score}
        </div>

        <div className={"row"} key={7}>
          <button
            type="button"
            className={"tryButton"}
            style={{
              display:
                istrue ||
                !this.props.props.exercises.attempted ||
                (this.props.state.buttons != "tryAgain" &&
                  this.props.state.buttons != i18n.t("MultipleChoice.tryAgain") &&
                  this.props.state.buttons != "Try Again" &&
                  this.props.state.buttons != "Tekrar Dene")
                  ? "none"
                  : "inline-block",
              ...buttonStyles,
              height: "48px",
            }}
            onClick={() => {
              this.refreshAnswers();
              this.props.props.tryAgainHandler();
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = state.buttonHoverBackgroundColor || "#ede9fe";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = state.buttonBackgroundColor || "#ede9fe";
            }}
          >
            {getButtonText(this.props.state.tryAgainText, "MultipleChoice.tryAgain")}
          </button>
          <button
            type="button"
            className={"tryButton"}
            style={{
              display:
                istrue ||
                !this.props.props.exercises.attempted ||
                (this.props.state.buttons != i18n.t("MultipleChoice.seeAnswer") &&
                  this.props.state.buttons != "seeAnswer")
                  ? "none"
                  : "inline-block",
              ...buttonStyles,
            }}
            onClick={() => this.props.props.seeAnswerHandler()}
            onMouseEnter={(e) =>
              (e.target.style.backgroundColor = state.buttonHoverBackgroundColor || "#ede9fe")
            }
            onMouseLeave={(e) =>
              (e.target.style.backgroundColor = state.buttonBackgroundColor || "#ede9fe")
            }
          >
            {getButtonText(this.props.state.seeAnswerText, "MultipleChoice.seeAnswer")}
          </button>
          <button
            type="button"
            className={"tryButton"}
            style={{
              display: this.props.props.exercises.attempted ? "none" : "inline-block",
              ...buttonStyles,
              height: "48px",
            }}
            onClick={() => {
              this.props.props.submitPage(this.props.props.currentView, this.props.props.id);
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = state.buttonHoverBackgroundColor || "#ede9fe";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = state.buttonBackgroundColor || "#ede9fe";
            }}
          >
            {getButtonText(this.props.state.checkAnswerText, "MultipleChoice.checkAnswer")}
          </button>
        </div>

        <style
          dangerouslySetInnerHTML={{
            __html: `
                            .orderingPlugin input[type="radio"]  {
                              background-color: transparent;
                            }
                           .orderingPlugin input[type="radio"]:checked:after {
                              background-color: ${quizColor};
                            }
                           /* tryAgain modunda tik/çarpı ikonu yok; sadece yeşil/kırmızı çerçeve. */
                           .matchingPlugin.matching-tryagain .vsl-status {
                              display: none;
                            }
                          `,
          }}
        />
      </div>
    );
  }

  refreshAnswers() {
    let position = this.generateRandomPositions(this.props.state.nBoxes);
    let position2 = this.generateRandomPositions(this.props.state.nBoxes);

    this.setState({ positions: position, positions2: position2 }, () => {
      this.props.props.setAnswer({ positionleft: position, positionright: position2 });
    });
  }

  generateRandomPositions(N) {
    let a = [];
    for (let i = 0; i < N; ++i) {
      a[i] = i;
    }
    return shuffle(a);
  }
  componentDidMount() {
    // Seed the initial (shuffled) order as the current answer so a learner who
    // submits without dragging is scored against what they see. Reordering now
    // goes through dnd-kit (VisorSortableList) — no more jQuery-UI sortable /
    // 50ms-timeout init (the old fragile path behind the "drag broken" bug).
    let attempted = this.props.props.exercises && this.props.props.exercises.attempted;
    if (!attempted) {
      this.props.props.setAnswer({
        positionleft: this.state.positions,
        positionright: this.state.positions2,
      });
    }
    this.syncRowHeights();
    // Re-run on width/text reflow (responsive, font load, i18n swap).
    if (typeof ResizeObserver !== "undefined" && this.rowContainerRef.current) {
      this._ro = new ResizeObserver(() => this.syncRowHeights());
      this._ro.observe(this.rowContainerRef.current);
    }
  }
}

/* eslint-enable react/prop-types */
